(function () {
  function initProductRedesign() {
    var template = document.getElementById('LucceGuideButton');
    if (!template) return;

    document.querySelectorAll('[id^="ProductSection-"]').forEach(function (root) {
      function fitBannerLabels() {
        root.querySelectorAll('.forever-piece-includes__toggle, .crafting-time-toggle, .ready-to-ship-banner').forEach(function (button) {
          var label = button.querySelector('.forever-piece-includes__label, .crafting-time-label, .ready-to-ship-banner__label');
          if (!label) return;
          if (!window.matchMedia('(max-width: 749px)').matches) { label.style.removeProperty('font-size'); return; }
          label.style.setProperty('font-size', '16px', 'important');
          var info = button.querySelector('.forever-piece-includes__info, .crafting-time-info, .ready-to-ship-banner__info');
          var icon = button.querySelector('.forever-piece-includes__icon, .crafting-time-icon, .ready-to-ship-banner__icon');
          var left = label.parentElement;
          var style = getComputedStyle(button);
          var available = button.clientWidth - parseFloat(style.paddingLeft) - parseFloat(style.paddingRight);
          if (info) available -= info.getBoundingClientRect().width + parseFloat(style.columnGap || 0);
          if (icon) available -= icon.getBoundingClientRect().width + parseFloat(getComputedStyle(left).columnGap || 0);
          var range = document.createRange();
          range.selectNodeContents(label);
          var width = range.getBoundingClientRect().width;
          if (width > available && available > 0) label.style.setProperty('font-size', (Math.floor(16 * available / width * 100) / 100) + 'px', 'important');
        });
      }
      fitBannerLabels();
      window.addEventListener('resize', fitBannerLabels);
      if (document.fonts) document.fonts.ready.then(fitBannerLabels);
      if (window.ResizeObserver) {
        var bannerResize = new ResizeObserver(fitBannerLabels);
        root.querySelectorAll('.forever-piece-includes, .crafting-time-wrap, .ready-to-ship-wrap').forEach(function (banner) { bannerResize.observe(banner); });
      }
      root.querySelectorAll('[data-lucce-carat-video] video, .lucce-carat-preview video').forEach(function (video) {
        if (video.dataset.caratPlaybackReady || !window.IntersectionObserver) return;
        video.dataset.caratPlaybackReady = 'true';
        video.muted = true;
        video.playsInline = true;
        new IntersectionObserver(function (entries) {
          entries.forEach(function (entry) {
            if (entry.isIntersecting && entry.intersectionRatio >= 0.15 && !window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
              var playback = video.play();
              if (playback) playback.catch(function () {});
            } else {
              video.pause();
            }
          });
        }, { threshold: [0, 0.15] }).observe(video);
      });
      root.querySelectorAll('[data-ready-toggle], [data-lucce-crafting-toggle]').forEach(function (button) {
        if (button.dataset.bannerReady) return;
        button.dataset.bannerReady = 'true';
        button.addEventListener('click', function () {
          var details = document.getElementById(button.getAttribute('aria-controls'));
          details.hidden = !details.hidden;
          button.setAttribute('aria-expanded', String(!details.hidden));
        });
      });
      root.querySelectorAll('.forever-piece-includes, .crafting-time-wrap, .ready-to-ship-wrap').forEach(function (banner) {
        var button = banner.querySelector('.forever-piece-includes__toggle, .crafting-time-toggle, [data-ready-toggle]');
        if (!button || banner.dataset.hoverReady) return;
        var details = document.getElementById(button.getAttribute('aria-controls'));
        if (!details) return;
        banner.dataset.hoverReady = 'true';
        function setOpen(open) {
          details.hidden = !open;
          button.setAttribute('aria-expanded', String(open));
        }
        button.addEventListener('mouseenter', function () {
          if (window.matchMedia('(hover: hover)').matches) setOpen(true);
        });
        banner.addEventListener('mouseleave', function () {
          if (window.matchMedia('(hover: hover)').matches && !banner.contains(document.activeElement)) setOpen(false);
        });
        banner.addEventListener('focusout', function (event) {
          if (!banner.contains(event.relatedTarget)) setOpen(false);
        });
      });
      function positionBuilderTotal() {
        var total = root.querySelector('#Customize-Total-Price-Wrapper');
        var button = root.querySelector('#Customize-Make-Selection2') || root.querySelector('#Customize-Make-Selection');
        var anchor = button && (button.closest('.customize-make-diamond-selction-container') || button);
        if (total && anchor && anchor.previousElementSibling !== total) anchor.before(total);
      }
      positionBuilderTotal();
      function matchPersonalizationWeight() {
        positionBuilderTotal();
        root.querySelectorAll('.product-single__description table, .product-secondary-description table').forEach(function (table) {
          table.querySelectorAll('td, th, p, div').forEach(function (block) {
            var walker = document.createTreeWalker(block, NodeFilter.SHOW_TEXT);
            var text;
            while ((text = walker.nextNode())) {
              var trimmed = text.nodeValue.replace(/^[\s\u00a0\u200b]+/, '');
              if (trimmed !== text.nodeValue) text.nodeValue = trimmed;
              if (trimmed) break;
            }
          });
        });
        root.querySelectorAll('.product__price').forEach(function (container) {
          var price = container.querySelector('.price');
          var priceTemplate = document.getElementById('LucceStartingPriceInfo');
          if (!price || !priceTemplate || container.querySelector('.customize-setting-price-info-icon-product-page')) return;
          var text = window.getComputedStyle(price, '::after').content.replace(/^["']|["']$/g, '').trim();
          if (text.toLowerCase() !== 'starting price') return;
          var info = priceTemplate.content.firstElementChild.cloneNode(true);
          var button = info.querySelector('button');
          var message = info.querySelector('.lucce-starting-price-message');
          message.id = 'StartingPriceInfo-' + root.id;
          button.setAttribute('aria-controls', message.id);
          function show(open) {
            message.hidden = !open;
            button.setAttribute('aria-expanded', String(open));
          }
          button.addEventListener('mouseenter', function () { show(true); });
          button.addEventListener('mouseleave', function () { show(false); });
          button.addEventListener('focus', function () { if (button.matches(':focus-visible')) show(true); });
          button.addEventListener('blur', function () { show(false); });
          button.addEventListener('click', function () { show(message.hidden); });
          document.addEventListener('click', function (event) { if (event.target !== button && !button.contains(event.target)) show(false); });
          container.appendChild(info);
        });
        root.querySelectorAll('.customize-setting-price-info-icon-product-page').forEach(function (priceIcon) {
          var priceContainer = priceIcon.closest('.product__price');
          var price = priceContainer && priceContainer.querySelector('.price');
          if (!price) return;
          var helperText = window.getComputedStyle(price, '::after').content.replace(/^["']|["']$/g, '');
          var helperRow = price.querySelector('.lucce-price-helper');
          if (!helperRow) {
            helperRow = document.createElement('span');
            helperRow.className = 'lucce-price-helper';
            var helperLabel = document.createElement('span');
            helperLabel.className = 'lucce-price-helper__label';
            helperRow.appendChild(helperLabel);
            price.appendChild(helperRow);
          }
          price.classList.add('lucce-price-helper-ready');
          var label = helperRow.querySelector('.lucce-price-helper__label');
          if (helperText !== 'none' && helperText !== 'normal' && label.textContent !== helperText) label.textContent = helperText;
          if (priceIcon.parentNode !== helperRow) helperRow.appendChild(priceIcon);
          var iconBounds = priceIcon.getBoundingClientRect();
          var containerBounds = priceContainer.getBoundingClientRect();
          priceContainer.style.setProperty('--lucce-price-info-arrow-left', (iconBounds.left - containerBounds.left + iconBounds.width / 2 - 9.5) + 'px');
        });
        var globoLabel = root.querySelector('.gpo-app .gpo-label .label-content, .gpo-app .gpo-label, .gpo-app label');
        var cartButton = root.querySelector('.product-form__cart-submit');
        if (cartButton) {
          var cartStyle = getComputedStyle(cartButton);
          root.querySelectorAll('.shopify-payment-button__button--unbranded').forEach(function (button) {
            ['font-family', 'font-size', 'font-weight', 'letter-spacing', 'line-height', 'padding', 'min-height'].forEach(function (property) {
              button.style.setProperty(property, cartStyle.getPropertyValue(property));
            });
          });
        }
        if (globoLabel) {
          root.style.setProperty('--lucce-personalization-weight', window.getComputedStyle(globoLabel).fontWeight);
        }
      }
      matchPersonalizationWeight();
      window.addEventListener('resize', matchPersonalizationWeight);
      if (document.fonts) document.fonts.ready.then(matchPersonalizationWeight);
      if (!root.dataset.personalizationWeightReady) {
        root.dataset.personalizationWeightReady = 'true';
        new MutationObserver(matchPersonalizationWeight).observe(root, { childList: true, subtree: true });
      }
      root.querySelectorAll('.product-single__meta label, #Customize-Diamond2-Label label').forEach(function (label) {
        var text = label.textContent.trim().toLowerCase();
        var kind = text === 'metal' ? 'metal' : text === 'ring size' ? 'ring' : text.indexOf('center diamond') === 0 ? 'carat' : null;
        if (kind === 'carat') label.classList.add('lucce-personalization-label');
        if (!kind || label.closest('.lucce-guide-label-row')) return;
        var dialog = document.getElementById('LucceGuide-' + kind);
        if (!dialog) return;
        var row = document.createElement('div');
        row.className = 'lucce-guide-label-row';
        label.parentNode.insertBefore(row, label);
        row.appendChild(label);
        var trigger = template.content.firstElementChild.cloneNode(true);
        trigger.querySelector('[data-guide-label]').textContent = dialog.dataset.guideLabel;
        trigger.setAttribute('aria-controls', dialog.id);
        trigger.addEventListener('click', function () { dialog.showModal(); });
        row.appendChild(trigger);
      });

      root.querySelectorAll('.diamond-range-slider input[type="range"]').forEach(function (slider) {
        function updateTrack() {
          var min = Number(slider.min || 0);
          var max = Number(slider.max || 100);
          var percent = max > min ? (Number(slider.value) - min) / (max - min) * 100 : 0;
          slider.style.setProperty('--carat-progress', percent + '%');
        }
        if (!slider.dataset.redesignReady) {
          slider.dataset.redesignReady = 'true';
          slider.addEventListener('input', updateTrack);
          slider.addEventListener('change', updateTrack);
        }
        updateTrack();
      });
    });

    document.querySelectorAll('[data-lucce-guide]').forEach(function (dialog) {
      if (dialog.dataset.initialized) return;
      dialog.dataset.initialized = 'true';
      dialog.querySelector('[data-guide-close]').addEventListener('click', function () { dialog.close(); });
      dialog.addEventListener('click', function (event) {
        if (event.target !== dialog) return;
        var rect = dialog.getBoundingClientRect();
        if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) dialog.close();
      });
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initProductRedesign);
  else initProductRedesign();
  document.addEventListener('shopify:section:load', initProductRedesign);
})();
